import { render } from "./Expression.vue?vue&type=template&id=c3427918&scoped=true"
import script from "./Expression.vue?vue&type=script&lang=js"
export * from "./Expression.vue?vue&type=script&lang=js"

import "./Expression.vue?vue&type=style&index=0&id=c3427918&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3427918"]])

export default __exports__